import { CardIntroduction } from "../CardIntroduction";
import { TCardIntroductionProps } from "../Card.config";
import { FC } from "react";

export const PreviewCardIntroduction: FC<TCardIntroductionProps> = ({ title }) => (
  <CardIntroduction title={title} className="p-2" />
);
